export const styles = (theme) => ({
  paper: {
    padding: "2rem",
  },
  marginTop: {
    marginTop: theme.spacing(3)
  },
  button: {
    float: "right",
    marginLeft: theme.spacing(1)
  },
})